import { ComponentType } from '../ui/shared/LinkTypes';
import { VisualStyle } from '../ui/shared/enums/VisualStyle';
/**
 * Default configuration for WordPressMenuItemDTO, providing baseline values for link data.
 */
export const defaultWordPressMenuItemDTO = {
    ID: 0,
    post_title: '',
    post_name: '',
    url: '',
    menu_order: 0,
    menu_item_parent: '0',
    link_type: ComponentType.Internal, // Using enum value
    variant: VisualStyle.Default, // Using enum value
    is_submenu: false
};
/**
 * Placeholder configuration for WordPressMenuItemDTO, useful for testing or development.
 */
export const placeholderWordPressMenuItemDTO = {
    ID: 1,
    post_title: 'Some Text For The Link',
    post_name: 'some-text-for-the-link',
    url: '/some-text-for-the-link',
    menu_order: 1,
    menu_item_parent: '12',
    link_type: ComponentType.Internal, // Using enum value
    variant: VisualStyle.Underlined, // Using enum value
    is_submenu: true
};
//# sourceMappingURL=WordPressMenuItemDTO.js.map